import { useMutation } from 'react-query';
import { useApiDownload, useApiQuery } from 'src/api';
import { useBuildVars } from 'src/config';

export type OrderHistoryQueryRequest = {
  discountTrackingId: string;
  page: number;
  pageSize: number;
};

export type OrderHistoryQueryResponse = {
  discountLines: {
    acopCreated: string;
    acopTrackingId: string;
    changeType: string;
    comment: string;
    createdBy: string;
    createdDate: string;
    discountAcopId: string;
    gdsTrackingId: number;
    id: string;
    orderCreated: string;
    orderLineNbr: string;
    orderLineQuantity: number;
    orderNumber: string;
    orderShipQuantity: number;
    quantity: number;
    sku: string;
  }[];
  totalCount: number;
};

export function useOrderHistoryQuery(params: OrderHistoryQueryRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<OrderHistoryQueryResponse>(
    `/system.webapi.gds/api/v1/GdsCoreApiQuantityAudit/GetDiscountAuditHistorByGdeTrackingId`,
    params,
    undefined,
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}

export function useDownloadOrderHistory(request: OrderHistoryQueryRequest) {
  const buildVars = useBuildVars();
  const apiGetDownload = useApiDownload({ host: buildVars.VP_API_BASE });
  return useMutation(() =>
    apiGetDownload(
      `/system.webapi.gds/api/v1/GdsCoreApiQuantityAudit/GetDiscountAuditHistorByGdeTrackingId.xlsx`,
      request
    )
  );
}
